<template>
  <v-container fluid justify="center" align="center">
    <v-row class="mt-3 mb-3" align="center" justify="center">
      <v-col cols="12" align="center" justify="center">
        <v-img
          :height="imageHeight"
          :width="imageWidth"
          :src="require('@/assets/img/imago_cmda.png')"
        ></v-img>
      </v-col>
    </v-row>
    <!-- Form -->
    <v-row justify="center" align="center">
      <v-col cols="12" xl="4" lg="4" md="6" sm="6" xs="10">
        <v-card
          :elevation="
            this.$vuetify.breakpoint.name == 'xs' ||
            this.$vuetify.breakpoint.name == 'md'
              ? 0
              : 4
          "
        >
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="email"
                :label="translations.prompt_email"
                type="email"
                :rules="emailValidationForm()"
                outlined
                clearable
              ></v-text-field>
              <v-text-field
                outlined
                v-model="password"
                :label="translations.prompt_password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                :rules="validation(translations.field_required)"
                @click:append="show = !show"
                v-on:keyup.enter="logIn"
              ></v-text-field>
              <!-- Actions -->
              <v-btn
                class="text-capitalize"
                color="secondary"
                block
                @click="logIn"
                :loading="loading"
              >
                {{ translations.action_sign_in }}
              </v-btn>
              <span
                style="color: #000000; font-size: 15px"
                @click="dialog = true"
                ><u>{{ translations.forgot_your_password }}</u></span
              >
            </v-form>
            <v-row class="mt-1">
              <v-col>
                <v-icon class="mr-1">mdi-android</v-icon>
                <a
                  class="subtitle-1 font-italic"
                  href="https://play.google.com/store/apps/details?id=com.solena.app_comercial_android&hl=es_MX"
                  >{{ translations.download_app }}</a
                >
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="3" class="py-0">
                <v-btn-toggle
                  divided
                  color="primary"
                  v-model="langSelected"
                  density="compact"
                  class=" justify-center"
                >
                  <div v-for="(lang, index) in langs" :key="index">
                    <v-btn @click="changeLanguage(lang.id)">
                      <v-img
                        width="30px"
                        class="mx-auto"
                        :src="lang.icon"
                      ></v-img>
                    </v-btn>
                  </div>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500">
      <v-card class="mb-3">
        <v-card-title class="subtitle-1 justify-center">
          {{ translations.forget_password_title }}
        </v-card-title>

        <v-card-text>
          <div class="d-flex justify-center mb-2 text-center">
            {{ translations.enter_email }}
          </div>
          <v-form ref="setPasswordFrom">
            <v-text-field
              dense
              v-model="emailForgot"
              :rules="emailValidationForm()"
              label="Correo"
              outlined
              clearable
            >
            </v-text-field>
          </v-form>

          <v-btn color="secondary" @click="setPassword" block>
            {{ translations.label_continue }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Vuex
import { mapActions, mapMutations, mapGetters } from "vuex";
// Validations
import { requiredValidation, emailValidation } from "@/helpers/validations.js";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      show: false,
      loading: false,
      dialog: false,
      emailForgot: "",
      langs: [
        {
          id: "en",
          name: "English",
          icon: require("@/assets/img/usa-flag.jpeg"),
        },
        {
          id: "pt",
          name: "Português",
          icon: require("@/assets/img/brazil-flag.png"),
        },
        {
          id: "es",
          name: "Español",
          icon: require("@/assets/img/mexico-flag.png"),
        },
         {
          id: "es-pr",
          name: "Español (Perú)",
          icon: require("@/assets/img/peru_flag.png"),
        },
      ],
      langSelected: 0,
    };
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("session", [
      "login",
      "sendRestartPassword",
      "changeLanguage",
    ]),
    ...mapMutations(["SET_LOADER"]),
    emailValidationForm() {
      return emailValidation(
        true,
        this.translations.field_required,
        this.translations.valid_email_required
      );
    },
    validation(value) {
      return requiredValidation(value);
    },
    async logIn() {
      try {
        this.SET_LOADER(true);
        const response = await this.login({
          email: this.email,
          password: this.password,
          tokenFirebase: localStorage.getItem("tokenFirebase"),
        });
        this.loading = false;

        // let goToPath = "";

        // if (JSON.parse(localStorage.getItem("openIntro")) === false) {
        //   goToPath = "/territory";
        // }
        // if (
        //   !localStorage.getItem("openIntro") ||
        //   JSON.parse(localStorage.getItem("openIntro")) === true
        // ) {
        //   localStorage.setItem("openIntro", true);
        //   goToPath = "/appIntro";
        // }
        if (
          response.user.role == "ORG_USER" ||
          response.user.role == "ORG_USER_ADMIN"
        ) {
          this.$router.push("/territory").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        } else {
          this.$router.push(`/seller-list/client/`).catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.login_error_check_info,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
    async setPassword() {
      try {
        if (this.$refs.setPasswordFrom.validate()) {
          this.SET_LOADER(true);
          this.dialog = false;
          let response = await this.sendRestartPassword(this.emailForgot);

          if (response.success === 1) {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: this.translations.send_email_password,
              timeout: 6000,
            });
          } else {
            this.dialog = true;
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.invalid_username,
              timeout: 4000,
            });
          }
        }
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.error_changing_password,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "200px";
        case "sm":
          return "260px";
        case "md":
          return "260px";
        case "lg":
          return "260px";
        case "xl":
          return "260px";
      }
    },
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "165px";
        case "sm":
          return "225px";
        case "md":
          return "225px";
        case "lg":
          return "225px";
        case "xl":
          return "225px";
      }
    },
  },
  mounted() {
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "en");
    } else {
      if (localStorage.getItem("language") == "en") {
        this.langSelected = 0;
      } else if (localStorage.getItem("language") == "es") {
        this.langSelected = 2;
      } else if (localStorage.getItem("language") == "pt") {
        this.langSelected = 1;
      } else if (localStorage.getItem("language") == "es-pr") {
        this.langSelected = 3;
      }
    }
  },
};
</script>

<style scoped>
/* #footer {
  width: 90%;
  position: absolute;
  margin: 3%;
  bottom: 3px;
  text-align: center;
} */
</style>
